import { useNavigate, useParams } from "react-router-dom";
import { FormEvent, useEffect, useState } from "react";

import EndPointService from "../services/endpoint";
import Dialog from "../components/Dialog";

import './Tracker.scss';
import '../components/Dialog.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { REGISTERED_PORTS, REGISTERED_SERVERS } from "../services/constants";
import Server from '../components/Server';

export default function Tracker () {
    const basePort = 32768;
    const [loaded, setLoaded] = useState(false);
    const [saving, setSaving] = useState(false);
    const [tofleet, setTofleet] = useState(false);
    const [name, setName] = useState('');
    const [hardware_id, setHardwareId] = useState('');
    const [server, setServer] = useState('');
    const [port, setPort] = useState(-1);
    const [updatable, setUpdatable] = useState(false);
    const [version, setVersion] = useState(-1);
    const [battery, setBattery] = useState(-1);
    const [last, setLast] = useState(-1);
    const [dialog, setDialog] = useState<string | null>(null)
    const [errorsOnName, setErrorsOnName] = useState<string[]>([])
    const [errorsOnServer, setErrorsOnServer] = useState<string[]>([])
    const [errorsOnPort, setErrorsOnPort] = useState<string[]>([])
    const [warnsOnName, setWarnsOnName] = useState<string[]>([])
    const [warnsOnServer, setWarnsOnServer] = useState<string[]>([])
    const [warnsOnPort, setWarnsOnPort] = useState<string[]>([])
    
    let { id: trackerId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (trackerId && !isNaN(Number(trackerId))) {
            EndPointService.tracker(Number(trackerId))
                .then(tracker => {
                    setLoaded(true);
                    setName(tracker.name)
                    setHardwareId(tracker.hardware_id)
                    setServer(tracker.server_url)
                    setPort(tracker.server_port)
                    setUpdatable(tracker.updatable)
                    setVersion(tracker.version)
                    setBattery(tracker.battery)
                    setLast(tracker.last)
                })
                .catch(() => {
                    setDialog(`Le tracker n'existe pas.`)
                })
        } else {
            setDialog(`Le numéro de tracker n'est pas bon.`)
        }
    }, [trackerId])

    useEffect(() => {
        const errors: string[] = [];
        if (!name.match(/^[0-9a-zA-Z-_ ]+$/)) {
            errors.push('Caractères autorisés: 0-9 a-z A-Z "-" "_" " "')
        }
        setErrorsOnName(errors);
        const warns: string[] = [];
        if (!name.match(/^[0-9]+$/)) {
            warns.push('Caractères recommandés: 0-9')
        }
        if (!name.match(/^[0-9]{1,4}$/)) {
            warns.push('Format recommandé: 1024')
        }
        setWarnsOnName(warns);
    }, [name])

    useEffect(() => {
        const errors: string[] = [];
        if (!server.match(/^[0-9a-zA-Z.]+$/)) {
            errors.push('Caractères autorisés: 0-9 a-z A-Z "."')
        }
        const regExpIP = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
        const regExpURL = /^[a-z][0-9a-z]*(\.[a-z][0-9a-z]*)+$/
        if (server.match(regExpIP) === null && server.match(regExpURL) === null) {
            errors.push('Format autorisé: IP (xxx.xxx.xxx.xxx) ou URL (xxx.mclloyd.com)')
        }
        if (server.length > 15) {
            errors.push('Longueur maximum: 15 carcatères')
        }
        setErrorsOnServer(errors);
        const warns: string[] = [];
        if (!REGISTERED_SERVERS.includes(server)) {
            warns.push(`Êtes vous sûr du nom de ce serveur ?`)
        }
        setWarnsOnServer(warns);
    }, [server])

    useEffect(() => {
        const errors: string[] = [];
        if (typeof port !== 'number') {
            errors.push('Doit être un nombre')
        }
        if (port%1>0) {
            errors.push('Doit être un nombre entier')
        }
        if (port<0) {
            errors.push('Doit être un nombre positif')
        }
        setErrorsOnPort(errors);
        const warns: string[] = [];
        if (!REGISTERED_PORTS.includes(port)) {
            warns.push(`Êtes vous sûr du port de ce serveur ?`)
        }
        setWarnsOnPort(warns);
    }, [port])

    function setFormName(value: string) {
        setName(value);
    }

    function setFormPort(value: string) {
        setPort(Number(value));
    }

    async function sendtofleet()
    {
        if (!hardware_id)
        {
            setDialog("Le tracker n'a pas d'ID hardware.");
            return;
        }
        if (!version)
        {
            setDialog("Le tracker n'a pas de version de firwnare.");
            return;
        }
        let els = name.split("_");
        if (els.length !== 3 && els[0] !== "Rev" && els[1].length !== 1)
        {
            setDialog("Le nom du tracker n'est pas sous la forme Rev_V_xxxx.");
            return;
        }
        if (isNaN(Number(els[2])))
        {
            setDialog("Le nom du tracker n'est pas sous la forme Rev_V_xxxx avec xxxx un nombre.");
            return;
        }
        let number = Number(els[2]);
        if (number < 1 || number > 9999)
        {
            setDialog("Le tracker n'a pas un numéro correct (entre 1 et 9999).");
            return;
        }
        setTofleet(true);
        try
        {
            const data: { success: boolean, message: string } = await EndPointService.sendtofleet(hardware_id, els[2], els[0]+els[1], String(version));
            setDialog(data.message);
        }
        catch (error)
        {
            setDialog(String(error));
        }
        setTofleet(false);
    }

    function handleSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();
        if (errorsOnName.length + errorsOnServer.length + errorsOnPort.length > 0 ) {
            setDialog('Il existe des erreurs. Corrigez les avant de valider.')
            return;
        }
        const id: number = Number(trackerId);
        setSaving(true);
        EndPointService.save({
            id,
            name,
            server_url: server,
            server_port: port,
            updatable,
        }).then(() => {
            setSaving(false);
            navigate("/trackers", { replace: false });
        }).catch(error => {
            if (error.response?.status && error.response.status === 412) {
                console.warn(error.response.data)
            } else {
                setDialog(`Une erreur est survenue lors de l'enregistrement du tracker`)
            }
            setSaving(false);
        })
    }

    return (
        <div className="tracker-page">
            { dialog && <Dialog message={dialog} onClose={() => setDialog(null)} /> }
            <h1 className="page-title">Tracker "{name}"</h1>
            <form className="block-form" onSubmit={handleSubmit}>
                <div className="line-input">
                    <label htmlFor="id">ID</label>
                    <input
                        id="id"
                        type="text"
                        value={trackerId}
                        disabled={!loaded}
                        readOnly={true}
                    />
                </div>
                <div className={'line-input'
                        + ( errorsOnName.length > 0 ? ' has-errors' : '')
                        + ( warnsOnName.length > 0 ? ' has-warns' : '')}>
                    <label htmlFor="name">Nom:</label>
                    <input
                        id="name"
                        type="text"
                        value={name}
                        disabled={!loaded}
                        onChange={(e) => setFormName(e.target.value)}
                    />
                    <span className="errors">
                        {
                            errorsOnName.map((error, index) => <span className="error" key={index}>{error}</span>)
                        }
                    </span>
                    <span className="warns">
                        {
                            warnsOnName.map((warn, index) => <span className="warn" key={index}>{warn}</span>)
                        }
                    </span>
                </div>
                <div className="line-input">
                    <label htmlFor="hardwareId">Hardware ID:</label>
                    <input
                        id="hardwareId"
                        type="text"
                        value={hardware_id}
                        disabled={!loaded}
                        readOnly={true}
                    />
                </div>
                <div className={'line-input'
                        + ( errorsOnServer.length > 0 ? ' has-errors' : '')
                        + ( warnsOnServer.length > 0 ? ' has-warns' : '')}>
                    <Server server={server} setServer={setServer} setPort={setPort}/>
                    <span className="errors">
                        {
                            errorsOnServer.map((error, index) => <span className="error" key={index}>{error}</span>)
                        }
                    </span>
                    <span className="warns">
                        {
                            warnsOnServer.map((warn, index) => <span className="warn" key={index}>{warn}</span>)
                        }
                    </span>
                </div>
                <div className={'line-input'
                        + ( errorsOnPort.length > 0 ? ' has-errors' : '')
                        + ( warnsOnPort.length > 0 ? ' has-warns' : '')}>
                    <div className="line-input-container">
                        <label htmlFor="port">Port:</label>
                        <input
                            id="port"
                            type="number"
                            value={port}
                            disabled={!loaded}
                            onChange={(e) => setFormPort(e.target.value)}
                        />
                        <button className="port-button" type="button" onClick={() => setFormPort(basePort.toString())}>{basePort}</button>
                    </div>
                    <span className="errors">
                        {
                            errorsOnPort.map((error, index) => <span className="error" key={index}>{error}</span>)
                        }
                    </span>
                    <span className="warns">
                        {
                            warnsOnPort.map((warn, index) => <span className="warn" key={index}>{warn}</span>)
                        }
                    </span>
                </div>
                <div className="line-input">
                    <label htmlFor="version">Version:</label>
                    <input
                        id="version"
                        type="text"
                        value={version}
                        disabled={!loaded}
                        readOnly
                    />
                </div>
                <div className="line-input">
                    <label htmlFor="version">Batterie:</label>
                    <input
                        id="battery"
                        type="text"
                        value={battery}
                        disabled={!loaded}
                        readOnly
                    />
                </div>
                <div className="line-input">
                    <label htmlFor="version">Last:</label>
                    <input
                        id="last"
                        type="text"
                        value={last}
                        disabled={!loaded}
                        readOnly
                    />
                </div>
                <div className="line-buttons">
                    <button className="cancel-button" type="button" onClick={() => {navigate("/trackers", { replace: false });}}>Annuler</button>
                    <button className="valid-button" type="submit" disabled={!loaded || saving}>
                        <span>Enregistrer</span>
                        { saving
                            ? <FontAwesomeIcon icon="spinner" spin />
                            : <FontAwesomeIcon icon="save" />
                        }
                    </button>
                    <button className="valid-button" type="button" disabled={!loaded || tofleet} onClick={() => {sendtofleet()}}>
                        <span>To Fleet</span>
                        { tofleet
                            ? <FontAwesomeIcon icon="spinner" spin />
                            : <FontAwesomeIcon icon="arrow-right" />
                        }
                    </button>
                </div>
            </form>
        </div>
    );
};